import gql from 'graphql-tag';

export const UpdateParticipantFile = gql`
  mutation UpdateParticipantFile(
    $organizationId: ID!
    $participantId: ID!
    $participantFileId: ID!
    $request: UpdateParticipantFileRequest!
  ) {
    updateParticipantFile(
      organizationId: $organizationId
      participantId: $participantId
      participantFileId: $participantFileId
      request: $request
    ) {
      id
    }
  }
`;
